const USD_FORMATTER = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
});
/**
 * Formats an LLM cost held as integer micro-USD (1 USD = 1,000,000), e.g. `US$1.25`.
 * `null` means the model has no price-table entry, rendered as "Unpriced" rather
 * than a misleading $0.00.
 */
export function formatCostMicroUsd(costMicroUsd) {
    if (costMicroUsd === null)
        return 'Unpriced';
    return USD_FORMATTER.format(costMicroUsd / 1_000_000);
}
